import { Injectable } from '@angular/core';
import { ClientAppConfig, DCarbonizeAppConfig } from './@types/shared/app-config';
import { InjectionToken } from '@angular/core';
import { environment } from 'environments/environment';
import { ClientBrand, clientBrand } from './theme/clients';

export const DCAR_APP_CONFIG = new InjectionToken<DCarbonizeAppConfig>('DCAR_APP_CONFIG');

export interface IConfigService {
    get getConfig(): DCarbonizeAppConfig;
    get getClient(): ClientAppConfig;
    get brand(): ClientBrand;
}

@Injectable({
    providedIn: 'root',
})
export class ConfigService implements IConfigService {
    public config: DCarbonizeAppConfig;
    /** The build's colours and typeface (theme/clients.ts). */
    public readonly brand: ClientBrand;

    constructor() {
        this.config = environment;
        this.brand = clientBrand(environment.client.name);
    }

    // getter: dcarb_config
    public get getConfig(): DCarbonizeAppConfig {
        return this.config;
    }

    public get getClient(): ClientAppConfig {
        return this.config.client;
    }
}
